












import { Component, Vue } from 'vue-property-decorator';
import { appModule } from '@/store/modules/ModuleApp';
import settings from '../../AppSettings';
@Component({
	name: 'Login'
})
/** Login */
export default class Login extends Vue {
	/** 获取appModule里面language数据 */
	public get language(): any {
		return appModule.language;
	}

	/** 更改title 命名等 */
	private handleSetLanguage(lang: string): any {
		this.$i18n.locale = lang;
		appModule.setLanguage(lang);
		document.documentElement.lang = lang;
		const title: any = this.$route.meta.title ? `${this.$t(`route.${this.$route.meta.title}`)} - ${settings.title}` : `${settings.title}`;

		document.title = title;
		this.$message({
			message: this.$t('components.changeLanguageTips').toString(),
			type: 'success'
		});
	}
}
